import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess211101Status: 'idle',
    startProcess211101Error: undefined as any,
    loadUserParamsProcess211101Status: 'idle',
    loadUserParamsProcess211101Error: undefined as any,

    process211101List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess211101 = createAsyncThunk('process211101Slice/startProcess211101', async ({ process211101 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess211101/`,
        prepareData(process211101),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess211101Status } = getState().process211101Slice
        return startProcess211101Status !== 'pending'
    }
})

export const loadUserParamsProcess211101 = createAsyncThunk('process211101Slice/loadUserParamsProcess211101', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess211101/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess211101Status } = getState().process211101Slice
        return loadUserParamsProcess211101Status !== 'pending'
    }
})

const Process211101Slice = createSlice({
    name: 'process211101Slice',
    initialState,
    reducers: {
        resetstartProcess211101: (state) => {
            state.job = undefined
            state.startProcess211101Error = undefined
        },
        resetstartProcess211101Error: (state) => {
            state.startProcess211101Error = undefined
        },
        resetloadUserParamsProcess211101: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess211101Error = undefined
        },
        resetloadUserParamsProcess211101Error: (state) => {
            state.loadUserParamsProcess211101Error = undefined
        },
        removeFromProcess211101ListById: (state, action) => {
            state.process211101List = state.process211101List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess211101ListByIds: (state, action) => {
            state.process211101List = state.process211101List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process211101List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess211101Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process211101List = []
            state.startProcess211101Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess211101.pending, (state) => {
            state.startProcess211101Status = 'pending'
            state.startProcess211101Error = undefined
        })
        builder.addCase(startProcess211101.fulfilled, (state, action) => {
            state.startProcess211101Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess211101.rejected, (state, action) => {
            state.startProcess211101Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess211101Error = action.error.message
            } else {
                state.startProcess211101Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess211101.pending, (state) => {
            state.loadUserParamsProcess211101Status = 'pending'
            state.loadUserParamsProcess211101Error = undefined
        })
        builder.addCase(loadUserParamsProcess211101.fulfilled, (state, action) => {
            state.loadUserParamsProcess211101Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess211101.rejected, (state, action) => {
            state.loadUserParamsProcess211101Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess211101Error = action.error.message
            } else {
                state.loadUserParamsProcess211101Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess211101,
    resetstartProcess211101Error,
    resetloadUserParamsProcess211101,
    resetloadUserParamsProcess211101Error,
    removeFromProcess211101ListById,
    removeFromProcess211101ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process211101Slice.actions
export default Process211101Slice.reducer
